import React from 'react';

export default function SouscriptionInfo({ settings = {}, sectionCfg = {} }) {
  if (sectionCfg.active === 0) return null;

  const bg       = sectionCfg.bg || settings['souscription.bg']     || '#FFFFFF';
  const color    = settings['souscription.text_color']              || '#1B4F8A';
  const fontSize = settings['souscription.font_size']               || '20';
  const text     = settings['souscription.text']                    || '';
  const legal    = settings['souscription.legal']                   || '';

  // Si le champ text est rempli, on l'utilise directement
  // Sinon on construit depuis les sous-champs
  const displayText = text || (() => {
    const parts = [];
    const label1 = settings['souscription.label']    || '';
    const val1   = settings['souscription.periode']  || '';
    const label2 = settings['souscription.label2']   || '';
    const val2   = settings['souscription.prix']     || '';
    const label3 = settings['souscription.label3']   || '';
    const val3   = settings['souscription.maturite'] || '';
    if (label1 && val1) parts.push(`${label1} : ${val1}`);
    if (label2 && val2) parts.push(`${label2} : ${val2}`);
    if (label3 && val3) parts.push(`${label3} : ${val3}`);
    return parts.join(' — ');
  })();

  if (!displayText) return null;

  // Détecter si fond sombre
  const isDark = (() => {
    const hex = bg.replace('#','');
    if (hex.length < 6) return false;
    const r=parseInt(hex.slice(0,2),16); const g=parseInt(hex.slice(2,4),16); const b=parseInt(hex.slice(4,6),16);
    return (r*299+g*587+b*114)/1000 < 128;
  })();

  const legalColor = isDark ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.35)';

  return (
    <section id="souscription" style={{ background: bg, paddingBottom: '2rem' }}>
      <style>{`
        .souscription-inner {
          max-width: 1200px; margin: 0 auto; padding: 0 1.2rem; text-align: center;
        }
        @media(min-width:768px){ .souscription-inner{ padding: 0 2rem; } }
      `}</style>
      <div className="souscription-inner">
        <h2 style={{
          fontSize: `${fontSize}px`,
          color: color,
          fontFamily: "'Playfair Display', serif",
          fontWeight: 500,
          lineHeight: 1.6,
          margin: 0,
        }}>
          {displayText}
        </h2>
        {legal && (
          <p style={{ fontSize: 11, color: legalColor, marginTop: '0.8rem', letterSpacing: '0.3px' }}>
            {legal}
          </p>
        )}
      </div>
    </section>
  );
}
